import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * The organization currently selected in the header — the common, app-wide
 * "active org". Persisted so it survives refreshes. Consumers resolve the
 * effective org via `useActiveOrgId` (falls back to the signed-in admin's org).
 */
interface ActiveOrgState {
  selectedOrgId: number | null;
}

const KEY = 'chunaav.activeOrg';

function loadInitial(): ActiveOrgState {
  try {
    const raw = localStorage.getItem(KEY);
    const id = raw ? Number(raw) : NaN;
    return { selectedOrgId: Number.isFinite(id) ? id : null };
  } catch {
    return { selectedOrgId: null };
  }
}

const activeOrgSlice = createSlice({
  name: 'activeOrg',
  initialState: loadInitial(),
  reducers: {
    setActiveOrg(state, action: PayloadAction<number | null>) {
      state.selectedOrgId = action.payload;
      try {
        if (action.payload == null) localStorage.removeItem(KEY);
        else localStorage.setItem(KEY, String(action.payload));
      } catch {
        /* ignore persistence errors */
      }
    },
  },
});

export const { setActiveOrg } = activeOrgSlice.actions;
export default activeOrgSlice.reducer;
